/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var bind = __webpack_require__(7);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  if (true) module.exports = definition();else if (typeof define == 'function' && _typeof(define.amd) == 'object') define(definition);else this[name] = definition();
}('domready', function () {

  var fns = [],
      _listener,
      doc = document,
      hack = doc.documentElement.doScroll,
      domContentLoaded = 'DOMContentLoaded',
      loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);

  if (!loaded) doc.addEventListener(domContentLoaded, _listener = function listener() {
    doc.removeEventListener(domContentLoaded, _listener);
    loaded = 1;
    while (_listener = fns.shift()) {
      _listener();
    }
  });

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  };
});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodelistToArray = nodelistToArray;
function nodelistToArray(nodeList) {
  return [].slice.call(nodeList);
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuid = uuid;
function uuid() {
  return "_" + Math.random().toString(36).substr(2, 9);
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(19);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(24);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(11);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(11);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(25);
var buildURL = __webpack_require__(8);
var buildFullPath = __webpack_require__(27);
var parseHeaders = __webpack_require__(30);
var isURLSameOrigin = __webpack_require__(31);
var createError = __webpack_require__(12);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(32);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(26);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = ['baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath'];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);

  var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _domready = __webpack_require__(1);

var _domready2 = _interopRequireDefault(_domready);

var _nodelistToArray = __webpack_require__(2);

var _uuid = __webpack_require__(3);

var _dhBasisLevendeStillbilde = __webpack_require__(17);

var _dhBasisLevendeStillbilde2 = _interopRequireDefault(_dhBasisLevendeStillbilde);

var _dhBasisCommon = __webpack_require__(35);

var _VideoLoop = __webpack_require__(36);

var _VideoLoop2 = _interopRequireDefault(_VideoLoop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootElementClassName = 'article-levende-stillbilde-root';

window[rootElementClassName] = window[rootElementClassName] || {};
window.isDhSentryInitiated = false;

var VIEWPORT_POSITION_ATTR = 'data-viewport-position';

function init() {
  initCustomElements();

  var elementsArray = (0, _nodelistToArray.nodelistToArray)(document.getElementsByClassName(rootElementClassName));
  elementsArray.filter(function (el) {
    return !isInitialized(el);
  }).forEach(function (el) {
    el.id = (0, _uuid.uuid)();
    window[rootElementClassName][el.id] = true;

    // Extract preloaded state sent from server
    var preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'));
    mount(el, preloadedState);
  });
}

function mount(el, preloadedState) {
  try {
    // Checks to see whether or not the video element is inside the a feature article cover
    var insideCover = Boolean(document.querySelector('.article-feature__cover #' + el.id));
    var captionEl = document.querySelector('#' + el.id + ' [data-caption]');
    if (insideCover && captionEl) {
      captionEl.parentNode.replaceChild(headingCaption(preloadedState.altText, preloadedState.byline), captionEl);
    }

    var videoWrapperElement = el.querySelector('.dh-video-wrapper');

    // eslint-disable-next-line no-unused-vars
    var elementObserver = new _dhBasisCommon.ElementIntersectionObserver([videoWrapperElement], function (intersections) {
      var element = intersections[0];
      var elementViewportPosition = videoWrapperElement.getAttribute(VIEWPORT_POSITION_ATTR);
      if (element.isIntersecting && elementViewportPosition === 'OUT-OF-VIEWPORT') {
        videoWrapperElement.setAttribute(VIEWPORT_POSITION_ATTR, 'IN-VIEWPORT');
      }
      if (!element.isIntersecting && elementViewportPosition === 'IN-VIEWPORT') {
        videoWrapperElement.setAttribute(VIEWPORT_POSITION_ATTR, 'OUT-OF-VIEWPORT');
      }
    });
  } catch (err) {
    // fail silently
  }
}

function headingCaption(altText, byline) {
  var captionContainer = document.createElement('div');
  captionContainer.innerHTML = '<span class=\'nrk-sr\'>' + altText + '</span><span>' + byline + '</span>';
  captionContainer.setAttribute('class', _VideoLoop2.default['byline']);
  captionContainer.setAttribute('data-caption', true);
  return captionContainer;
}

function initCustomElements() {
  if (typeof customElements.get('dh-lvs-basis-levende-stillbilde') === 'undefined') {
    customElements.define('dh-lvs-basis-levende-stillbilde', _dhBasisLevendeStillbilde2.default);
  }
}

function isInitialized(el) {
  return el.id && window[rootElementClassName][el.id];
}

(0, _domready2.default)(function () {
  if (!('customElements' in window)) {
    __webpack_require__(37);
  }
  if (!('IntersectionObserver' in window)) {
    __webpack_require__(38);
  }
  init();
});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dhBasisCommon = __webpack_require__(18);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

;
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);


var STATE_ATTR = 'data-state';
var VIEWPORT_POSITION_ATTR = 'data-viewport-position';
var DISABLE_FORCED_ATTRIBUTES_ATTR = 'disable-forced-attributes';
var IS_PAUSED = 'is-paused';
var AUTOPLAY_BLOCKED = 'autoplay-blocked';

var isVisible = function isVisible(child) {
  return child.offsetWidth > 0 || child.offsetHeight > 0;
};

var LevendeStillbilde = function (_CustomElement2) {
  _inherits(LevendeStillbilde, _CustomElement2);

  function LevendeStillbilde() {
    _classCallCheck(this, LevendeStillbilde);

    var _this = _possibleConstructorReturn(this, (LevendeStillbilde.__proto__ || Object.getPrototypeOf(LevendeStillbilde)).apply(this, arguments));

    _this._disconnecting = false;

    _this._handlePlayChange = function () {
      _this.isPaused = _this.visibleVideoElement.paused;
    };

    _this._updatePlayState = function () {
      if (!_this.visibleVideoElement) {
        return;
      }

      if (_this._shouldPlay()) {
        _this._playVideo();
      } else {
        _this._pauseVideo();
      }
    };

    _this._handleResize = function () {
      _this._updatePlayState();

      _this._preload();
    };
    return _this;
  }

  _createClass(LevendeStillbilde, [{
    key: 'connectedCallback',
    value: function connectedCallback() {
      this._setVideoAttributes();

      this._setEventListeners();

      this._updatePlayState();
    }
  }, {
    key: 'disconnectedCallback',
    value: function disconnectedCallback() {
      this._disconnecting = true;

      this._removeEventListeners();
    }
  }, {
    key: 'attributeChangedCallback',
    value: function attributeChangedCallback(name, prevValue, newValue) {
      var reducedMotion = (0, _dhBasisCommon.testReducedMotion)();
      var valueChanged = prevValue !== newValue;

      if ((name === STATE_ATTR || name === VIEWPORT_POSITION_ATTR) && !reducedMotion) {
        if (valueChanged) {
          this._updatePlayState();

          if (name === VIEWPORT_POSITION_ATTR && newValue === 'IN-VIEWPORT') {
            this._preload();
          }
        }
      }
    }
  }, {
    key: '_setEventListeners',
    value: function _setEventListeners() {
      var _this2 = this;

      window.addEventListener('resize', this._handleResize);
      this.videoElements.forEach(function (el) {
        el.addEventListener('pause', _this2._handlePlayChange);
        el.addEventListener('play', _this2._handlePlayChange);
        el.addEventListener('loadedmetadata', _this2._updatePlayState);
      });
    }
  }, {
    key: '_removeEventListeners',
    value: function _removeEventListeners() {
      var _this3 = this;

      window.removeEventListener('resize', this._handleResize);
      this.videoElements.forEach(function (el) {
        el.removeEventListener('pause', _this3._handlePlayChange);
        el.removeEventListener('play', _this3._handlePlayChange);
        el.removeEventListener('loadedmetadata', _this3._updatePlayState);
      });
    }
  }, {
    key: '_setVideoAttributes',
    value: function _setVideoAttributes() {
      if (!this.disableForcedAttributes) {
        this.videoElements.forEach(function (el) {
          el.setAttribute('playsInline', '');
          el.setAttribute('loop', '');
          el.setAttribute('disableRemotePlayback', '');
          el.setAttribute('x-webkit-airplay', 'deny');
        });
      }
    }
  }, {
    key: '_shouldPlay',
    value: function _shouldPlay() {
      return this.visibleVideoElement.readyState >= 1 && this.state === 'ACTIVE' && this.viewportPosition === 'IN-VIEWPORT';
    }
  }, {
    key: '_preload',
    value: function _preload() {
      if (this.visibleVideoElement.getAttribute('preload') !== 'auto') {
        this.visibleVideoElement.setAttribute('preload', 'auto');
      }
    }
  }, {
    key: '_playVideo',
    value: function _playVideo() {
      var _this4 = this;

      var videoElement = this.visibleVideoElement;

      if (videoElement.paused && !this.autoplayBlocked) {
        var playPromise = videoElement.play() || Promise.resolve();
        playPromise.catch(function (e) {
          console.error(e);
          _this4.autoplayBlocked = true;
        });
      }
    }
  }, {
    key: '_pauseVideo',
    value: function _pauseVideo() {
      var videoElement = this.visibleVideoElement;

      if (!videoElement.paused) {
        videoElement.pause();
      }
    }
  }, {
    key: 'visibleVideoElement',
    get: function get() {
      return this.videoElements.find(isVisible);
    }
  }, {
    key: 'videoElements',
    get: function get() {
      return (0, _dhBasisCommon.toArray)(this.querySelectorAll('video'));
    }
  }, {
    key: 'disableForcedAttributes',
    get: function get() {
      return this.hasAttribute(DISABLE_FORCED_ATTRIBUTES_ATTR);
    }
  }, {
    key: 'state',
    get: function get() {
      return this.getAttribute(STATE_ATTR);
    },
    set: function set(val) {
      this.setAttribute(STATE_ATTR, val);
    }
  }, {
    key: 'isPaused',
    get: function get() {
      return this.getAttribute(IS_PAUSED);
    },
    set: function set(val) {
      if (val) {
        this.setAttribute(IS_PAUSED, '');
      } else {
        this.removeAttribute(IS_PAUSED);
      }
    }
  }, {
    key: 'autoplayBlocked',
    get: function get() {
      return this.hasAttribute(AUTOPLAY_BLOCKED) || false;
    },
    set: function set(val) {
      (0, _dhBasisCommon.toggleAttribute)(this, AUTOPLAY_BLOCKED, val);
    }
  }, {
    key: 'viewportPosition',
    get: function get() {
      return this.getAttribute(VIEWPORT_POSITION_ATTR);
    },
    set: function set(val) {
      this.setAttribute(VIEWPORT_POSITION_ATTR, val);
    }
  }], [{
    key: 'observedAttributes',
    get: function get() {
      return [STATE_ATTR, DISABLE_FORCED_ATTRIBUTES_ATTR, VIEWPORT_POSITION_ATTR];
    }
  }]);

  return LevendeStillbilde;
}(_CustomElement);

exports.default = LevendeStillbilde;
//# sourceMappingURL=dh-basis-levende-stillbilde.esm.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withinStops = exports.withinRange = exports.toggleAttribute = exports.toArray = exports.testReducedMotion = exports.setAttribute = exports.mergeVideoloopProps = exports.mergeMediaProps = exports.mergeMapProps = exports.mergeImageProps = exports.dispatchEvent = exports.closest = exports.addStyle = exports.VerticalScroll = exports.HorizontalScroll = exports.ElementIntersectionObserver = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(6);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/* eslint-disable compat/compat */
var defaultConfig = {
  rootMargin: '0px 0px 0px 0px',
  threshold: [0, 0.5, 1]
};

var ElementIntersectionObserver = function () {
  function ElementIntersectionObserver(elements, onChange, config) {
    var _this = this;

    _classCallCheck(this, ElementIntersectionObserver);

    this.intersections = void 0;
    this.elements = void 0;
    this.elements = elements.slice(0);
    this.intersections = elements.map(function (target) {
      return {
        target: target,
        isIntersecting: false,
        ratio: null
      };
    });
    this.intersectionObserver = new IntersectionObserver(function (entries) {
      var intersections = _this.intersections.slice(0);
      entries.forEach(function (entry) {
        var idx = elements.indexOf(entry.target);
        intersections.splice(idx, 1, {
          target: entry.target,
          isIntersecting: entry.isIntersecting,
          ratio: entry.intersectionRatio
        });
      });
      _this.intersections = intersections;
      onChange(_this.intersections);
    }, _objectSpread2({}, defaultConfig, {}, config));
    elements.forEach(function (elm) {
      return _this.intersectionObserver.observe(elm);
    });
  }

  _createClass(ElementIntersectionObserver, [{
    key: "disconnect",
    value: function disconnect() {
      var _this2 = this;

      // Unregister trigger elements
      this.elements.forEach(function (elm) {
        return _this2.intersectionObserver.unobserve(elm);
      }); // Disconnect intersection observer

      this.intersectionObserver.disconnect();
    }
  }]);

  return ElementIntersectionObserver;
}();

function toggleAttribute(el, name, boolValue) {
  if (!el) {
    return;
  }

  var nextValue;

  if (typeof boolValue !== 'undefined') {
    nextValue = !!boolValue;
  } else {
    nextValue = el.hasAttribute(name);
  }

  if (nextValue) {
    el.setAttribute(name, '');
  } else {
    el.removeAttribute(name);
  }
}
function setAttribute(el, name, nextValue) {
  if (!el) {
    return;
  }

  if (nextValue) {
    el.setAttribute(name, nextValue);
  } else {
    el.removeAttribute(name);
  }
}
var closest = function () {
  var proto = typeof window === 'undefined' ? {} : window.Element.prototype;
  var match = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;

  if (proto.closest) {
    return function (el, css) {
      return el.closest(css);
    };
  } else {
    return function (el, css) {
      for (; el; el = el.parentElement) {
        if (match.call(el, css)) return el;
      }

      return null;
    };
  }
}();
function addStyle(nodeName, css) {
  var key = "style-".concat(nodeName.toLowerCase());
  var min = css.replace(/\/\*[^!][^*]*\*\//g, '').replace(/\s*(^|[:;,{}]|$)\s*/g, '$1');
  document.getElementById(key) || document.head.insertAdjacentHTML('afterbegin', "<style id=\"".concat(key, "\">").concat(min, "</style>"));
}
function toArray(nodeList) {
  return [].slice.call(nodeList);
}
function dispatchEvent(element, name) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var ignore = "prevent_recursive_dispatch_maximum_callstack".concat(name);
  var event;
  if (element[ignore]) return true; // We are already processing this event, so skip sending a new one
  else element[ignore] = true; // Add name to dispatching ignore

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(name, {
      bubbles: true,
      cancelable: true,
      detail: detail
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(name, true, true, detail);
  } // IE reports incorrect event.defaultPrevented
  // but correct return value on element.dispatchEvent


  var result = element.dispatchEvent(event);
  element[ignore] = null; // Remove name from dispatching ignore

  return result; // Follow W3C standard for return value
}

function easeOutQuint(t) {
  return 1 + --t * t * t * t * t;
}

var VerticalScroll = function () {
  function VerticalScroll(container) {
    _classCallCheck(this, VerticalScroll);

    this.container = void 0;
    this.container = container;
  }

  _createClass(VerticalScroll, [{
    key: "to",
    value: function to(top) {
      var _this3 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var from = this.container.scrollTop;
      var distance = top - from;
      var startTime = null;

      var loop = function loop(currentTime) {
        if (!startTime) {
          startTime = currentTime - 1;
        }

        var timeElapsed = currentTime - startTime;
        _this3.container.scrollTop = from + distance * easeOutQuint(timeElapsed / duration);

        if (timeElapsed < duration) {
          window.requestAnimationFrame(loop);
        } else {
          _this3.container.scrollTop = top;
        }
      };

      window.requestAnimationFrame(loop);
    }
  }]);

  return VerticalScroll;
}();

var HorizontalScroll = function () {
  function HorizontalScroll(container) {
    _classCallCheck(this, HorizontalScroll);

    this.container = void 0;
    this.container = container;
  }

  _createClass(HorizontalScroll, [{
    key: "to",
    value: function to(left) {
      var _this4 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var from = this.container.scrollLeft;
      var distance = left - from;
      var startTime = null;

      var loop = function loop(currentTime) {
        if (!startTime) {
          startTime = currentTime - 1;
        }

        var timeElapsed = currentTime - startTime;
        _this4.container.scrollLeft = from + distance * easeOutQuint(timeElapsed / duration);

        if (timeElapsed < duration) {
          window.requestAnimationFrame(loop);
        } else {
          _this4.container.scrollLeft = left;
          callback && callback();
        }
      };

      window.requestAnimationFrame(loop);
    }
  }]);

  return HorizontalScroll;
}();

function testReducedMotion() {
  if (typeof window !== 'undefined') {
    return !!window.matchMedia && window.matchMedia('(prefers-reduced-motion)').matches;
  }

  return false;
}

var name = process.env.npm_package_name;
var version = process.env.npm_package_version;

function createGqlApi() {
  return {
    get: function get(query, url) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref5, data, errors;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _axios2.default)({
                  method: 'POST',
                  url: url,
                  data: {
                    query: query,
                    variables: null
                  },
                  timeout: 7500,
                  headers: {
                    'User-Agent': "".concat(name, "/").concat(version, " (node/isomorphic-fetch)"),
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                  }
                }).then(function (res) {
                  return res.data;
                });

              case 2:
                _ref5 = _context.sent;
                data = _ref5.data;
                errors = _ref5.errors;

                if (!(errors && errors.length)) {
                  _context.next = 7;
                  break;
                }

                throw Error(errors);

              case 7:
                return _context.abrupt("return", transformResponse(data));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }))();
    }
  };
}

var gqlApi = createGqlApi();

function pngFragment(options) {
  var aspects = options.aspectRatios.map(function (ratio) {
    var sizes = ratio.sizes.map(function (s) {
      return "w".concat(s, ": url(quality: ").concat(ratio.quality || '0.7', ", width: ").concat(s, ", format: png)");
    }).join('\n');
    return "".concat(ratio.id, ": crop(aspect: ").concat(ratio.id, ") {\n        ").concat(ratio.id === 'original' ? 'aspect' : '', "\n        ").concat(sizes, "\n      }");
  }).join('\n');
  return "\nfragment imageCropsPng on Image {\n  title,\n  creators,\n  credit,\n  category,\n  ".concat(aspects, "\n}\n");
}

function jpgFragment(options) {
  var aspects = options.aspectRatios.map(function (ratio) {
    var sizes = ratio.sizes.map(function (size) {
      return "w".concat(size, ": url(quality: ").concat(ratio.quality || '0.7', ", width: ").concat(size, ")");
    }).join('\n');
    return "".concat(ratio.id, ": crop(aspect: ").concat(ratio.id, ") {\n        ").concat(ratio.id === 'original' ? 'aspect' : '', "\n        ").concat(sizes, "\n      }");
  }).join('\n');
  return "\nfragment imageCropsJpg on Image {\n  title,\n  creators,\n  credit,\n  category,\n  ".concat(aspects, "\n}\n");
}
/**
 * Transforms a series of image sections to a Polopoly GraphQL API query
 */

function createQuery(imageObjects, options) {
  var images = getImageIds(imageObjects);
  return "\n    ".concat(createBase(images, options), "\n    query {\n      ").concat(images.map(getImage).join('\n'), "\n    }");
}
var IMAGE_PROPS = ['vertical', 'horizontal'];

function getImageIds(imageObjects) {
  if (imageObjects.some(function (image) {
    return !image;
  })) {
    throw new Error('Undefined image object');
  }

  return imageObjects.reduce(function (result, image) {
    var format = image.format || image.advanced && image.advanced.format || 'jpg';
    /* Image can be stored directly on image object */

    if (image.id && !result.find(function (el) {
      return el.id === image.id;
    })) {
      result.push({
        id: image.id,
        format: format
      });
    }
    /* or on a predefined set of image properties */

    IMAGE_PROPS.forEach(function (prop) {
      var value = image[prop];

      if (value && value.id && !result.find(function (el) {
        return el.id === value.id;
      })) {
        result.push({
          id: value.id,
          format: format
        });
      }
    });
    return result;
  }, []);
}

function getImage(_ref) {
  var id = _ref.id,
      _ref$format = _ref.format,
      format = _ref$format === undefined ? 'jpg' : _ref$format;


  if (format === 'png') {
    return "".concat(transformId(id), ": model(id: \"").concat(id, "\") {\n      ...imageCropsPng\n    }");
  }

  return "".concat(transformId(id), ": model(id: \"").concat(id, "\") {\n    ...imageCropsJpg\n  }");
}

function createBase(imageObjects, options) {
  var containsJpg = imageObjects.filter(function (el) {
    return el.format === 'jpg';
  }).length > 0;
  var containsPng = imageObjects.filter(function (el) {
    return el.format === 'png';
  }).length > 0;
  return "\n    ".concat(containsJpg ? jpgFragment(options) : '', "\n    ").concat(containsPng ? pngFragment(options) : '', "\n  ");
}
/**
 * Transforns a polopoly id to something that can be used as a key in a GraphQL query
 * Example: '1.14252981' -> 'id_1_14252981'
 */

function transformId(id) {
  return "id".concat(id.replace(/\./g, '__'));
}
/**
 * Transforns an already transformed polopoly id back to a regular polopoly id
 * Example: ''id_1_14252981' -> 1.14252981'
 */

function transformBackId(id) {
  return id.replace('id', '').replace(/__/g, '.');
}

function transformResponse(response) {
  return Object.keys(response).reduce(function (res, key) {
    var transformedKey = transformBackId(key);
    res[transformedKey] = response[key];
    return res;
  }, {});
}

function fromEntries(items) {
  return [].concat(_toConsumableArray(items)).reduce(function (obj, _ref) {
    var _ref6 = _slicedToArray(_ref, 2),
        key = _ref6[0],
        val = _ref6[1];

    obj[key] = val;
    return obj;
  }, {});
}

function traverse(obj, filter) {
  var matches = [];

  if (filter(obj)) {
    /* Object is a match, returning */
    matches.push(obj);
  }

  return [].concat(matches, _toConsumableArray(Object.entries(obj).filter(function (_ref2) {
    var _ref7 = _slicedToArray(_ref2, 2),
        _ = _ref7[0],
        value = _ref7[1];

    return !!value;
  }).map(function (_ref3) {
    var _ref8 = _slicedToArray(_ref3, 2),
        _ = _ref8[0],
        value = _ref8[1];

    if (Array.isArray(value)) {
      return value.map(function (item) {
        return traverse(item, filter);
      }).reduce(function (acc, val) {
        return acc.concat(val);
      }, []);
    } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
      return traverse(value, filter);
    } else {
      return null;
    }
  }).reduce(function (acc, val) {
    return acc.concat(val);
  }, []).filter(Boolean)));
}
/*
 * Traverses the props tree and fetches data for all image objects
 * */

function prefetchImageData(_x, _x2) {
  return _prefetchImageData.apply(this, arguments);
}

function _prefetchImageData() {
  _prefetchImageData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(props, options) {
    var imageObjects, query;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            imageObjects = traverse(props, function (value) {
              return value.type && value.type.startsWith('image');
            });

            if (!(imageObjects.length > 0)) {
              _context2.next = 6;
              break;
            }

            if (options.gqlApiUrl) {
              _context2.next = 4;
              break;
            }

            throw new Error("Missing option 'gqlApiUrl'");

          case 4:
            query = createQuery(imageObjects, options);
            return _context2.abrupt("return", gqlApi.get(query, options.gqlApiUrl));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _prefetchImageData.apply(this, arguments);
}

var imageProps = ['vertical', 'horizontal'];
function mergeImageProps(props, imageUrls) {
  if ('id' in props) {
    return _objectSpread2({}, props, {}, imageUrls[props.id]);
  } else {
    return fromEntries(Object.entries(props).map(function (_ref4) {
      var _ref9 = _slicedToArray(_ref4, 2),
          key = _ref9[0],
          value = _ref9[1];

      if (imageProps.indexOf(key) !== -1) {
        return [key, mergeImageProps(value, imageUrls)];
      } else {
        return [key, value];
      }
    }));
  }
}

function mergeVideoloopProps(_x) {
  return _mergeVideoloopProps.apply(this, arguments);
}

function _mergeVideoloopProps() {
  _mergeVideoloopProps = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(props) {
    var objects;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Promise.all(Object.keys(props).map(
            /*#__PURE__*/
            function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(key) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(key === 'horizontal' || key === 'vertical')) {
                          _context3.next = 9;
                          break;
                        }

                        _context3.t0 = _objectSpread2;
                        _context3.t1 = {
                          id: key
                        };
                        _context3.t2 = props[key];
                        _context3.next = 6;
                        return getVideoSrc(props[key]);

                      case 6:
                        _context3.t3 = _context3.sent;
                        _context3.t4 = {
                          videos: _context3.t3
                        };
                        return _context3.abrupt("return", (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t4));

                      case 9:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, this);
              }));

              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 2:
            objects = _context4.sent;
            return _context4.abrupt("return", _objectSpread2({}, props, {}, objects.filter(Boolean).reduce(function (accumulator, current) {
              accumulator[current.id] = current;
              delete accumulator[current.id].id;
              return accumulator;
            }, {})));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));
  return _mergeVideoloopProps.apply(this, arguments);
}

function getVideoSrc(_x2) {
  return _getVideoSrc.apply(this, arguments);
}

function _getVideoSrc() {
  _getVideoSrc = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(videoObj) {
    var hasVideoUrl, videos, basePath;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            hasVideoUrl = videoObj && videoObj !== 'null';

            if (!hasVideoUrl) {
              _context5.next = 9;
              break;
            }

            _context5.next = 4;
            return getVideos(videoObj.url);

          case 4:
            videos = _context5.sent;
            basePath = extractBasePathFromUrl(videoObj.url);
            return _context5.abrupt("return", videos.map(function (video) {
              return {
                type: getTypeFromHeight(video.height),
                poster: "".concat(basePath, "/").concat(video.stillFileName),
                aspectRatio: video.displayAspectRatio,
                height: video.height,
                sources: {
                  mp4: "".concat(basePath, "/").concat(video.videoFileName)
                }
              };
            }));

          case 9:
            return _context5.abrupt("return", null);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));
  return _getVideoSrc.apply(this, arguments);
}

function extractBasePathFromUrl(url) {
  var decodedUrl = url.replace(/%2F/g, '/');
  return decodedUrl.substr(0, decodedUrl.lastIndexOf('/'));
}

function getVideos(_x3) {
  return _getVideos.apply(this, arguments);
}

function _getVideos() {
  _getVideos = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(url) {
    var videoPayload;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getVideoPayload(url);

          case 2:
            videoPayload = _context6.sent;
            return _context6.abrupt("return", videoPayload.movingStills);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));
  return _getVideos.apply(this, arguments);
}

function getVideoPayload(url) {
  return _axios2.default.get(url, {
    timeout: 2000
  }).then(function (_ref) {
    var data = _ref.data;

    return data;
  });
}

function getTypeFromHeight(height) {
  switch (height) {
    case 360:
      return 'small';

    case 720:
      return 'medium';

    case 1080:
      return 'large';

    default:
      return 'large';
  }
}

function mergeMapProps(_x) {
  return _mergeMapProps.apply(this, arguments);
}

function _mergeMapProps() {
  _mergeMapProps = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(props) {
    var id, rest;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            id = props.id, rest = _objectWithoutProperties(props, ["id"]);
            _context7.t0 = _objectSpread2;
            _context7.t1 = {
              id: id
            };
            _context7.t2 = rest;
            _context7.next = 6;
            return getMapDefinition(id);

          case 6:
            _context7.t3 = _context7.sent;
            _context7.t4 = {
              definition: _context7.t3
            };
            return _context7.abrupt("return", (0, _context7.t0)(_context7.t1, _context7.t2, _context7.t4));

          case 9:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));
  return _mergeMapProps.apply(this, arguments);
}

function getMapDefinition(_x2) {
  return _getMapDefinition.apply(this, arguments);
}

function _getMapDefinition() {
  _getMapDefinition = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (id) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return");

          case 2:
            return _context8.abrupt("return", _axios2.default.get("https://dh.nrk.no/atlas/v1/definition?id=".concat(id), {
              timeout: 2000
            }).then(function (_ref) {
              var data = _ref.data;

              return data;
            }));

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));
  return _getMapDefinition.apply(this, arguments);
}

function fromEntries$1(items) {
  return [].concat(_toConsumableArray(items)).reduce(function (obj, _ref) {
    var _ref10 = _slicedToArray(_ref, 2),
        key = _ref10[0],
        val = _ref10[1];

    obj[key] = val;
    return obj;
  }, {});
}

var defaultOptions = {
  image: {
    gqlApiUrl: 'https://www.nrk.no/api/graphql',
    aspectRatios: [{
      id: 'F11',
      sizes: ['450', '768', '1280']
    }, {
      id: 'F34',
      sizes: ['450', '768', '1280']
    }, {
      id: 'F169',
      sizes: ['900', '1280', '2400']
    }, {
      id: 'original',
      sizes: ['450', '768', '1280', '2400']
    }]
  }
};
function mergeMediaProps(_x, _x2, _x3) {
  return _mergeMediaProps.apply(this, arguments);
}

function _mergeMediaProps() {
  _mergeMediaProps = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(props, options, imageData) {
    var mergedOptions, type, imageDataStored, mergedProps, mappedEntries;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            mergedOptions = {
              image: _objectSpread2({}, defaultOptions.image, {}, options === null || options === void 0 ? void 0 : options.image)
            };
            type = props.type;
            _context10.t0 = imageData;

            if (_context10.t0) {
              _context10.next = 7;
              break;
            }

            _context10.next = 6;
            return prefetchImageData(props, mergedOptions.image);

          case 6:
            _context10.t0 = _context10.sent;

          case 7:
            imageDataStored = _context10.t0;
            mergedProps = props;

            if (!(type && type.startsWith('videoloop'))) {
              _context10.next = 15;
              break;
            }

            _context10.next = 12;
            return mergeVideoloopProps(props);

          case 12:
            mergedProps = _context10.sent;
            _context10.next = 25;
            break;

          case 15:
            if (!(type && type.startsWith('image'))) {
              _context10.next = 21;
              break;
            }

            _context10.next = 18;
            return mergeImageProps(props, imageDataStored);

          case 18:
            mergedProps = _context10.sent;
            _context10.next = 25;
            break;

          case 21:
            if (!(type && type.startsWith('map'))) {
              _context10.next = 25;
              break;
            }

            _context10.next = 24;
            return mergeMapProps(props, imageDataStored);

          case 24:
            mergedProps = _context10.sent;

          case 25:
            _context10.next = 27;
            return Promise.all(Object.entries(mergedProps).map(
            /*#__PURE__*/
            function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref3) {
                var _ref11, key, value, mergedArray;

                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        _ref11 = _slicedToArray(_ref3, 2), key = _ref11[0], value = _ref11[1];

                        if (!Array.isArray(value)) {
                          _context9.next = 8;
                          break;
                        }

                        _context9.next = 4;
                        return Promise.all(value.map(function (item) {
                          return mergeMediaProps(item, options, imageDataStored);
                        }));

                      case 4:
                        mergedArray = _context9.sent;
                        return _context9.abrupt("return", [key, mergedArray]);

                      case 8:
                        if (!((typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && value !== null)) {
                          _context9.next = 16;
                          break;
                        }

                        _context9.t0 = key;
                        _context9.next = 12;
                        return mergeMediaProps(value, options, imageDataStored);

                      case 12:
                        _context9.t1 = _context9.sent;
                        return _context9.abrupt("return", [_context9.t0, _context9.t1]);

                      case 16:
                        return _context9.abrupt("return", [key, value]);

                      case 17:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9, this);
              }));

              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 27:
            mappedEntries = _context10.sent;
            return _context10.abrupt("return", fromEntries$1(mappedEntries));

          case 29:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));
  return _mergeMediaProps.apply(this, arguments);
}

var MAX_SAFE_INTEGER = 9007199254740991;
function withinRange(current) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var stop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_SAFE_INTEGER;
  return current >= start && current <= stop;
}
function withinStops(currentTime, stops, targetStop) {
  var nrOfStops = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var uniqueStops = stops.filter(unique);
  var targetTime = stops[targetStop];
  var prevTime = uniqueStops[uniqueStops.indexOf(targetTime) - nrOfStops];
  var nextTime = uniqueStops[uniqueStops.indexOf(targetTime) + nrOfStops];
  return withinRange(currentTime, prevTime, nextTime);
}

function unique(value, index, self) {
  return self.indexOf(value) === index;
}

exports.ElementIntersectionObserver = ElementIntersectionObserver;
exports.HorizontalScroll = HorizontalScroll;
exports.VerticalScroll = VerticalScroll;
exports.addStyle = addStyle;
exports.closest = closest;
exports.dispatchEvent = dispatchEvent;
exports.mergeImageProps = mergeImageProps;
exports.mergeMapProps = mergeMapProps;
exports.mergeMediaProps = mergeMediaProps;
exports.mergeVideoloopProps = mergeVideoloopProps;
exports.setAttribute = setAttribute;
exports.testReducedMotion = testReducedMotion;
exports.toArray = toArray;
exports.toggleAttribute = toggleAttribute;
exports.withinRange = withinRange;
exports.withinStops = withinStops;
//# sourceMappingURL=dh-basis-common.esm.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(7);
var Axios = __webpack_require__(20);
var mergeConfig = __webpack_require__(13);
var defaults = __webpack_require__(10);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(14);
axios.CancelToken = __webpack_require__(33);
axios.isCancel = __webpack_require__(9);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(34);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var buildURL = __webpack_require__(8);
var InterceptorManager = __webpack_require__(21);
var dispatchRequest = __webpack_require__(22);
var mergeConfig = __webpack_require__(13);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(23);
var isCancel = __webpack_require__(9);
var defaults = __webpack_require__(10);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(12);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function () {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(28);
var combineURLs = __webpack_require__(29);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(14);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withinRange = exports.toggleAttribute = exports.toArray = exports.testReducedMotion = exports.setAttribute = exports.mergeVideoloopProps = exports.mergeMediaProps = exports.mergeMapProps = exports.mergeImageProps = exports.dispatchEvent = exports.closest = exports.addStyle = exports.VerticalScroll = exports.HorizontalScroll = exports.ElementIntersectionObserver = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(6);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/* eslint-disable compat/compat */
var defaultConfig = {
  rootMargin: '0px 0px 0px 0px',
  threshold: [0, 0.5, 1]
};

var ElementIntersectionObserver = function () {
  function ElementIntersectionObserver(elements, onChange, config) {
    var _this = this;

    _classCallCheck(this, ElementIntersectionObserver);

    this.intersections = void 0;
    this.elements = void 0;
    this.elements = elements.slice(0);
    this.intersections = elements.map(function (target) {
      return {
        target: target,
        isIntersecting: false,
        ratio: null
      };
    });
    this.intersectionObserver = new IntersectionObserver(function (entries) {
      var intersections = _this.intersections.slice(0);
      entries.forEach(function (entry) {
        var idx = elements.indexOf(entry.target);
        intersections.splice(idx, 1, {
          target: entry.target,
          isIntersecting: entry.isIntersecting,
          ratio: entry.intersectionRatio
        });
      });
      _this.intersections = intersections;
      onChange(_this.intersections);
    }, _objectSpread2({}, defaultConfig, {}, config));
    elements.forEach(function (elm) {
      return _this.intersectionObserver.observe(elm);
    });
  }

  _createClass(ElementIntersectionObserver, [{
    key: "disconnect",
    value: function disconnect() {
      var _this2 = this;

      // Unregister trigger elements
      this.elements.forEach(function (elm) {
        return _this2.intersectionObserver.unobserve(elm);
      }); // Disconnect intersection observer

      this.intersectionObserver.disconnect();
    }
  }]);

  return ElementIntersectionObserver;
}();

function toggleAttribute(el, name, boolValue) {
  if (!el) {
    return;
  }

  var nextValue;

  if (typeof boolValue !== 'undefined') {
    nextValue = !!boolValue;
  } else {
    nextValue = el.hasAttribute(name);
  }

  if (nextValue) {
    el.setAttribute(name, '');
  } else {
    el.removeAttribute(name);
  }
}
function setAttribute(el, name, nextValue) {
  if (!el) {
    return;
  }

  if (nextValue) {
    el.setAttribute(name, nextValue);
  } else {
    el.removeAttribute(name);
  }
}
var closest = function () {
  var proto = typeof window === 'undefined' ? {} : window.Element.prototype;
  var match = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;

  if (proto.closest) {
    return function (el, css) {
      return el.closest(css);
    };
  } else {
    return function (el, css) {
      for (; el; el = el.parentElement) {
        if (match.call(el, css)) return el;
      }

      return null;
    };
  }
}();
function addStyle(nodeName, css) {
  var key = "style-".concat(nodeName.toLowerCase());
  var min = css.replace(/\/\*[^!][^*]*\*\//g, '').replace(/\s*(^|[:;,{}]|$)\s*/g, '$1');
  document.getElementById(key) || document.head.insertAdjacentHTML('afterbegin', "<style id=\"".concat(key, "\">").concat(min, "</style>"));
}
function toArray(nodeList) {
  return [].slice.call(nodeList);
}
function dispatchEvent(element, name) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var ignore = "prevent_recursive_dispatch_maximum_callstack".concat(name);
  var event;
  if (element[ignore]) return true; // We are already processing this event, so skip sending a new one
  else element[ignore] = true; // Add name to dispatching ignore

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(name, {
      bubbles: true,
      cancelable: true,
      detail: detail
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(name, true, true, detail);
  } // IE reports incorrect event.defaultPrevented
  // but correct return value on element.dispatchEvent


  var result = element.dispatchEvent(event);
  element[ignore] = null; // Remove name from dispatching ignore

  return result; // Follow W3C standard for return value
}

function easeOutQuint(t) {
  return 1 + --t * t * t * t * t;
}

var VerticalScroll = function () {
  function VerticalScroll(container) {
    _classCallCheck(this, VerticalScroll);

    this.container = void 0;
    this.container = container;
  }

  _createClass(VerticalScroll, [{
    key: "to",
    value: function to(top) {
      var _this3 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var from = this.container.scrollTop;
      var distance = top - from;
      var startTime = null;

      var loop = function loop(currentTime) {
        if (!startTime) {
          startTime = currentTime - 1;
        }

        var timeElapsed = currentTime - startTime;
        _this3.container.scrollTop = from + distance * easeOutQuint(timeElapsed / duration);

        if (timeElapsed < duration) {
          window.requestAnimationFrame(loop);
        } else {
          _this3.container.scrollTop = top;
        }
      };

      window.requestAnimationFrame(loop);
    }
  }]);

  return VerticalScroll;
}();

var HorizontalScroll = function () {
  function HorizontalScroll(container) {
    _classCallCheck(this, HorizontalScroll);

    this.container = void 0;
    this.container = container;
  }

  _createClass(HorizontalScroll, [{
    key: "to",
    value: function to(left) {
      var _this4 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var from = this.container.scrollLeft;
      var distance = left - from;
      var startTime = null;

      var loop = function loop(currentTime) {
        if (!startTime) {
          startTime = currentTime - 1;
        }

        var timeElapsed = currentTime - startTime;
        _this4.container.scrollLeft = from + distance * easeOutQuint(timeElapsed / duration);

        if (timeElapsed < duration) {
          window.requestAnimationFrame(loop);
        } else {
          _this4.container.scrollLeft = left;
          callback && callback();
        }
      };

      window.requestAnimationFrame(loop);
    }
  }]);

  return HorizontalScroll;
}();

function testReducedMotion() {
  if (typeof window !== 'undefined') {
    return !!window.matchMedia && window.matchMedia('(prefers-reduced-motion)').matches;
  }

  return false;
}

var name = process.env.npm_package_name;
var version = process.env.npm_package_version;

function createGqlApi() {
  return {
    get: function get(query, url) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref5, data, errors;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _axios2.default)({
                  method: 'POST',
                  url: url,
                  data: {
                    query: query,
                    variables: null
                  },
                  timeout: 7500,
                  headers: {
                    'User-Agent': "".concat(name, "/").concat(version, " (node/isomorphic-fetch)"),
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                  }
                }).then(function (res) {
                  return res.data;
                });

              case 2:
                _ref5 = _context.sent;
                data = _ref5.data;
                errors = _ref5.errors;

                if (!(errors && errors.length)) {
                  _context.next = 7;
                  break;
                }

                throw Error(errors);

              case 7:
                return _context.abrupt("return", transformResponse(data));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }))();
    }
  };
}

var gqlApi = createGqlApi();

function pngFragment(options) {
  var aspects = options.aspectRatios.map(function (ratio) {
    var sizes = ratio.sizes.map(function (s) {
      return "w".concat(s, ": url(quality: ").concat(ratio.quality || '0.7', ", width: ").concat(s, ", format: png)");
    }).join('\n');
    return "".concat(ratio.id, ": crop(aspect: ").concat(ratio.id, ") {\n        ").concat(ratio.id === 'original' ? 'aspect' : '', "\n        ").concat(sizes, "\n      }");
  }).join('\n');
  return "\nfragment imageCropsPng on Image {\n  title,\n  creators,\n  credit,\n  category,\n  ".concat(aspects, "\n}\n");
}

function jpgFragment(options) {
  var aspects = options.aspectRatios.map(function (ratio) {
    var sizes = ratio.sizes.map(function (size) {
      return "w".concat(size, ": url(quality: ").concat(ratio.quality || '0.7', ", width: ").concat(size, ")");
    }).join('\n');
    return "".concat(ratio.id, ": crop(aspect: ").concat(ratio.id, ") {\n        ").concat(ratio.id === 'original' ? 'aspect' : '', "\n        ").concat(sizes, "\n      }");
  }).join('\n');
  return "\nfragment imageCropsJpg on Image {\n  title,\n  creators,\n  credit,\n  category,\n  ".concat(aspects, "\n}\n");
}
/**
 * Transforms a series of image sections to a Polopoly GraphQL API query
 */

function createQuery(imageObjects, options) {
  var images = getImageIds(imageObjects);
  return "\n    ".concat(createBase(images, options), "\n    query {\n      ").concat(images.map(getImage).join('\n'), "\n    }");
}
var IMAGE_PROPS = ['vertical', 'horizontal'];

function getImageIds(imageObjects) {
  if (imageObjects.some(function (image) {
    return !image;
  })) {
    throw new Error('Undefined image object');
  }

  return imageObjects.reduce(function (result, image) {
    var format = image.advanced && image.advanced.format || 'jpg';
    /* Image can be stored directly on image object */

    if (image.id && !result.find(function (el) {
      return el.id === image.id;
    })) {
      result.push({
        id: image.id,
        format: format
      });
    }
    /* or on a predefined set of image properties */

    IMAGE_PROPS.forEach(function (prop) {
      var value = image[prop];

      if (value && value.id && !result.find(function (el) {
        return el.id === value.id;
      })) {
        result.push({
          id: value.id,
          format: format
        });
      }
    });
    return result;
  }, []);
}

function getImage(_ref) {
  var id = _ref.id,
      _ref$format = _ref.format,
      format = _ref$format === undefined ? 'jpg' : _ref$format;


  if (format === 'png') {
    return "".concat(transformId(id), ": model(id: \"").concat(id, "\") {\n      ...imageCropsPng\n    }");
  }

  return "".concat(transformId(id), ": model(id: \"").concat(id, "\") {\n    ...imageCropsJpg\n  }");
}

function createBase(imageObjects, options) {
  var containsJpg = imageObjects.filter(function (el) {
    return el.format === 'jpg';
  }).length > 0;
  var containsPng = imageObjects.filter(function (el) {
    return el.format === 'png';
  }).length > 0;
  return "\n    ".concat(containsJpg ? jpgFragment(options) : '', "\n    ").concat(containsPng ? pngFragment(options) : '', "\n  ");
}
/**
 * Transforns a polopoly id to something that can be used as a key in a GraphQL query
 * Example: '1.14252981' -> 'id_1_14252981'
 */

function transformId(id) {
  return "id".concat(id.replace(/\./g, '__'));
}
/**
 * Transforns an already transformed polopoly id back to a regular polopoly id
 * Example: ''id_1_14252981' -> 1.14252981'
 */

function transformBackId(id) {
  return id.replace('id', '').replace(/__/g, '.');
}

function transformResponse(response) {
  return Object.keys(response).reduce(function (res, key) {
    var transformedKey = transformBackId(key);
    res[transformedKey] = response[key];
    return res;
  }, {});
}

function fromEntries(items) {
  return [].concat(_toConsumableArray(items)).reduce(function (obj, _ref) {
    var _ref6 = _slicedToArray(_ref, 2),
        key = _ref6[0],
        val = _ref6[1];

    obj[key] = val;
    return obj;
  }, {});
}

function traverse(obj, filter) {
  if (filter(obj)) {
    /* Object is a match, returning */
    return [obj];
  } else {
    return Object.entries(obj).filter(function (_ref2) {
      var _ref7 = _slicedToArray(_ref2, 2),
          _ = _ref7[0],
          value = _ref7[1];

      return !!value;
    }).map(function (_ref3) {
      var _ref8 = _slicedToArray(_ref3, 2),
          _ = _ref8[0],
          value = _ref8[1];

      if (Array.isArray(value)) {
        return value.map(function (item) {
          return traverse(item, filter);
        }).reduce(function (acc, val) {
          return acc.concat(val);
        }, []);
      } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
        return traverse(value, filter);
      } else {
        return null;
      }
    }).reduce(function (acc, val) {
      return acc.concat(val);
    }, []).filter(Boolean);
  }
}
/*
 * Traverses the props tree and fetches data for all image objects
 * */

function prefetchImageData(_x, _x2) {
  return _prefetchImageData.apply(this, arguments);
}

function _prefetchImageData() {
  _prefetchImageData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(props, options) {
    var imageObjects, query;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            imageObjects = traverse(props, function (value) {
              return value.type === 'image';
            });

            if (!(imageObjects.length > 0)) {
              _context2.next = 6;
              break;
            }

            if (options.gqlApiUrl) {
              _context2.next = 4;
              break;
            }

            throw new Error("Missing option 'gqlApiUrl'");

          case 4:
            query = createQuery(imageObjects, options);
            return _context2.abrupt("return", gqlApi.get(query, options.gqlApiUrl));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _prefetchImageData.apply(this, arguments);
}

var imageProps = ['vertical', 'horizontal'];
function mergeImageProps(props, imageUrls) {
  if ('id' in props) {
    return _objectSpread2({}, props, {}, imageUrls[props.id]);
  } else {
    return fromEntries(Object.entries(props).map(function (_ref4) {
      var _ref9 = _slicedToArray(_ref4, 2),
          key = _ref9[0],
          value = _ref9[1];

      if (imageProps.indexOf(key) !== -1) {
        return [key, mergeImageProps(value, imageUrls)];
      } else {
        return [key, value];
      }
    }));
  }
}

function mergeVideoloopProps(_x) {
  return _mergeVideoloopProps.apply(this, arguments);
}

function _mergeVideoloopProps() {
  _mergeVideoloopProps = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(props) {
    var objects;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Promise.all(Object.keys(props).map(
            /*#__PURE__*/
            function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(key) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(key === 'horizontal' || key === 'vertical')) {
                          _context3.next = 9;
                          break;
                        }

                        _context3.t0 = _objectSpread2;
                        _context3.t1 = {
                          id: key
                        };
                        _context3.t2 = props[key];
                        _context3.next = 6;
                        return getVideoSrc(props[key]);

                      case 6:
                        _context3.t3 = _context3.sent;
                        _context3.t4 = {
                          videos: _context3.t3
                        };
                        return _context3.abrupt("return", (0, _context3.t0)(_context3.t1, _context3.t2, _context3.t4));

                      case 9:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, this);
              }));

              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 2:
            objects = _context4.sent;
            return _context4.abrupt("return", _objectSpread2({}, props, {}, objects.filter(Boolean).reduce(function (accumulator, current) {
              accumulator[current.id] = current;
              delete accumulator[current.id].id;
              return accumulator;
            }, {})));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));
  return _mergeVideoloopProps.apply(this, arguments);
}

function getVideoSrc(_x2) {
  return _getVideoSrc.apply(this, arguments);
}

function _getVideoSrc() {
  _getVideoSrc = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(videoObj) {
    var hasVideoUrl, videos, basePath;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            hasVideoUrl = videoObj && videoObj !== 'null';

            if (!hasVideoUrl) {
              _context5.next = 9;
              break;
            }

            _context5.next = 4;
            return getVideos(videoObj.url);

          case 4:
            videos = _context5.sent;
            basePath = extractBasePathFromUrl(videoObj.url);
            return _context5.abrupt("return", videos.map(function (video) {
              return {
                type: getTypeFromHeight(video.height),
                poster: "".concat(basePath, "/").concat(video.stillFileName),
                aspectRatio: video.displayAspectRatio,
                height: video.height,
                sources: {
                  mp4: "".concat(basePath, "/").concat(video.videoFileName)
                }
              };
            }));

          case 9:
            return _context5.abrupt("return", null);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));
  return _getVideoSrc.apply(this, arguments);
}

function extractBasePathFromUrl(url) {
  var decodedUrl = url.replace(/%2F/g, '/');
  return decodedUrl.substr(0, decodedUrl.lastIndexOf('/'));
}

function getVideos(_x3) {
  return _getVideos.apply(this, arguments);
}

function _getVideos() {
  _getVideos = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(url) {
    var videoPayload;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getVideoPayload(url);

          case 2:
            videoPayload = _context6.sent;
            return _context6.abrupt("return", videoPayload.movingStills);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));
  return _getVideos.apply(this, arguments);
}

function getVideoPayload(url) {
  return _axios2.default.get(url, {
    timeout: 2000
  }).then(function (_ref) {
    var data = _ref.data;

    return data;
  });
}

function getTypeFromHeight(height) {
  switch (height) {
    case 360:
      return 'small';

    case 720:
      return 'medium';

    case 1080:
      return 'large';

    default:
      return 'large';
  }
}

function mergeMapProps(_x) {
  return _mergeMapProps.apply(this, arguments);
}

function _mergeMapProps() {
  _mergeMapProps = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(props) {
    var id, rest;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            id = props.id, rest = _objectWithoutProperties(props, ["id"]);
            _context7.t0 = _objectSpread2;
            _context7.t1 = {
              id: id
            };
            _context7.t2 = rest;
            _context7.next = 6;
            return getMapDefinition(id);

          case 6:
            _context7.t3 = _context7.sent;
            _context7.t4 = {
              definition: _context7.t3
            };
            return _context7.abrupt("return", (0, _context7.t0)(_context7.t1, _context7.t2, _context7.t4));

          case 9:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));
  return _mergeMapProps.apply(this, arguments);
}

function getMapDefinition(_x2) {
  return _getMapDefinition.apply(this, arguments);
}

function _getMapDefinition() {
  _getMapDefinition = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (id) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return");

          case 2:
            return _context8.abrupt("return", _axios2.default.get("https://dh.nrk.no/atlas/v1/definition?id=".concat(id), {
              timeout: 2000
            }).then(function (_ref) {
              var data = _ref.data;

              return data;
            }));

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));
  return _getMapDefinition.apply(this, arguments);
}

function fromEntries$1(items) {
  return [].concat(_toConsumableArray(items)).reduce(function (obj, _ref) {
    var _ref10 = _slicedToArray(_ref, 2),
        key = _ref10[0],
        val = _ref10[1];

    obj[key] = val;
    return obj;
  }, {});
}

var defaultOptions = {
  image: {
    gqlApiUrl: 'https://www.nrk.no/api/graphql',
    aspectRatios: [{
      id: 'F11',
      sizes: ['450', '768', '1280']
    }, {
      id: 'F34',
      sizes: ['450', '768', '1280']
    }, {
      id: 'F169',
      sizes: ['900', '1280', '2400']
    }, {
      id: 'original',
      sizes: ['450', '768', '1280', '2400']
    }]
  }
};
function mergeMediaProps(_x, _x2, _x3) {
  return _mergeMediaProps.apply(this, arguments);
}

function _mergeMediaProps() {
  _mergeMediaProps = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(props, options, imageData) {
    var mergedOptions, imageDataStored, mappedEntries;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            mergedOptions = {
              image: _objectSpread2({}, defaultOptions.image, {}, options === null || options === void 0 ? void 0 : options.image)
            };
            _context10.t0 = imageData;

            if (_context10.t0) {
              _context10.next = 6;
              break;
            }

            _context10.next = 5;
            return prefetchImageData(props, mergedOptions.image);

          case 5:
            _context10.t0 = _context10.sent;

          case 6:
            imageDataStored = _context10.t0;

            if (!(props.type === 'videoloop')) {
              _context10.next = 11;
              break;
            }

            return _context10.abrupt("return", mergeVideoloopProps(props));

          case 11:
            if (!(props.type === 'image')) {
              _context10.next = 15;
              break;
            }

            return _context10.abrupt("return", mergeImageProps(props, imageDataStored));

          case 15:
            if (!(props.type === 'map')) {
              _context10.next = 19;
              break;
            }

            return _context10.abrupt("return", mergeMapProps(props, imageDataStored));

          case 19:
            _context10.next = 21;
            return Promise.all(Object.entries(props).map(
            /*#__PURE__*/
            function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref2) {
                var _ref11, key, value, mergedArray;

                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        _ref11 = _slicedToArray(_ref2, 2), key = _ref11[0], value = _ref11[1];

                        if (!Array.isArray(value)) {
                          _context9.next = 8;
                          break;
                        }

                        _context9.next = 4;
                        return Promise.all(value.map(function (item) {
                          return mergeMediaProps(item, options, imageDataStored);
                        }));

                      case 4:
                        mergedArray = _context9.sent;
                        return _context9.abrupt("return", [key, mergedArray]);

                      case 8:
                        if (!((typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && value !== null)) {
                          _context9.next = 16;
                          break;
                        }

                        _context9.t0 = key;
                        _context9.next = 12;
                        return mergeMediaProps(value, options, imageDataStored);

                      case 12:
                        _context9.t1 = _context9.sent;
                        return _context9.abrupt("return", [_context9.t0, _context9.t1]);

                      case 16:
                        return _context9.abrupt("return", [key, value]);

                      case 17:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9, this);
              }));

              return function (_x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 21:
            mappedEntries = _context10.sent;
            return _context10.abrupt("return", fromEntries$1(mappedEntries));

          case 23:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));
  return _mergeMediaProps.apply(this, arguments);
}

var MAX_SAFE_INTEGER = 9007199254740991;
function withinRange(current) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var stop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_SAFE_INTEGER;
  return current >= start && current <= stop;
}

exports.ElementIntersectionObserver = ElementIntersectionObserver;
exports.HorizontalScroll = HorizontalScroll;
exports.VerticalScroll = VerticalScroll;
exports.addStyle = addStyle;
exports.closest = closest;
exports.dispatchEvent = dispatchEvent;
exports.mergeImageProps = mergeImageProps;
exports.mergeMapProps = mergeMapProps;
exports.mergeMediaProps = mergeMediaProps;
exports.mergeVideoloopProps = mergeVideoloopProps;
exports.setAttribute = setAttribute;
exports.testReducedMotion = testReducedMotion;
exports.toArray = toArray;
exports.toggleAttribute = toggleAttribute;
exports.withinRange = withinRange;
//# sourceMappingURL=dh-basis-common.esm.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"standaloneVideo":"dh-video-standaloneVideo","small":"dh-video-small","medium":"dh-video-medium","large":"dh-video-large","horizontalVideo":"dh-video-horizontalVideo","verticalVideo":"dh-video-verticalVideo","videoLoop":"dh-video-videoLoop","videoLoop__fallbackImage":"dh-video-videoLoop__fallbackImage","wrapper":"dh-video-wrapper","byline":"dh-video-byline","videoLoop--played":"dh-video-videoLoop--played"};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  /*
  
   Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
   This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
   The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
   The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
   Code distributed by Google as part of the polymer project is also
   subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  'use strict';
  var n = window.Document.prototype.createElement,
      p = window.Document.prototype.createElementNS,
      aa = window.Document.prototype.importNode,
      ba = window.Document.prototype.prepend,
      ca = window.Document.prototype.append,
      da = window.DocumentFragment.prototype.prepend,
      ea = window.DocumentFragment.prototype.append,
      q = window.Node.prototype.cloneNode,
      r = window.Node.prototype.appendChild,
      t = window.Node.prototype.insertBefore,
      u = window.Node.prototype.removeChild,
      v = window.Node.prototype.replaceChild,
      x = Object.getOwnPropertyDescriptor(window.Node.prototype, "textContent"),
      y = window.Element.prototype.attachShadow,
      z = Object.getOwnPropertyDescriptor(window.Element.prototype, "innerHTML"),
      A = window.Element.prototype.getAttribute,
      B = window.Element.prototype.setAttribute,
      C = window.Element.prototype.removeAttribute,
      D = window.Element.prototype.getAttributeNS,
      E = window.Element.prototype.setAttributeNS,
      F = window.Element.prototype.removeAttributeNS,
      G = window.Element.prototype.insertAdjacentElement,
      fa = window.Element.prototype.insertAdjacentHTML,
      ha = window.Element.prototype.prepend,
      ia = window.Element.prototype.append,
      ja = window.Element.prototype.before,
      ka = window.Element.prototype.after,
      la = window.Element.prototype.replaceWith,
      ma = window.Element.prototype.remove,
      na = window.HTMLElement,
      H = Object.getOwnPropertyDescriptor(window.HTMLElement.prototype, "innerHTML"),
      oa = window.HTMLElement.prototype.insertAdjacentElement,
      pa = window.HTMLElement.prototype.insertAdjacentHTML;var qa = new Set();"annotation-xml color-profile font-face font-face-src font-face-uri font-face-format font-face-name missing-glyph".split(" ").forEach(function (a) {
    return qa.add(a);
  });function ra(a) {
    var b = qa.has(a);a = /^[a-z][.0-9_a-z]*-[\-.0-9_a-z]*$/.test(a);return !b && a;
  }var sa = document.contains ? document.contains.bind(document) : document.documentElement.contains.bind(document.documentElement);
  function I(a) {
    var b = a.isConnected;if (void 0 !== b) return b;if (sa(a)) return !0;for (; a && !(a.__CE_isImportDocument || a instanceof Document);) {
      a = a.parentNode || (window.ShadowRoot && a instanceof ShadowRoot ? a.host : void 0);
    }return !(!a || !(a.__CE_isImportDocument || a instanceof Document));
  }function J(a) {
    var b = a.children;if (b) return Array.prototype.slice.call(b);b = [];for (a = a.firstChild; a; a = a.nextSibling) {
      a.nodeType === Node.ELEMENT_NODE && b.push(a);
    }return b;
  }
  function K(a, b) {
    for (; b && b !== a && !b.nextSibling;) {
      b = b.parentNode;
    }return b && b !== a ? b.nextSibling : null;
  }
  function L(a, b, c) {
    for (var f = a; f;) {
      if (f.nodeType === Node.ELEMENT_NODE) {
        var d = f;b(d);var e = d.localName;if ("link" === e && "import" === d.getAttribute("rel")) {
          f = d.import;void 0 === c && (c = new Set());if (f instanceof Node && !c.has(f)) for (c.add(f), f = f.firstChild; f; f = f.nextSibling) {
            L(f, b, c);
          }f = K(a, d);continue;
        } else if ("template" === e) {
          f = K(a, d);continue;
        }if (d = d.__CE_shadowRoot) for (d = d.firstChild; d; d = d.nextSibling) {
          L(d, b, c);
        }
      }f = f.firstChild ? f.firstChild : K(a, f);
    }
  }function M(a, b, c) {
    a[b] = c;
  };function ta(a) {
    var b = document;this.c = a;this.a = b;this.b = void 0;N(this.c, this.a);"loading" === this.a.readyState && (this.b = new MutationObserver(this.f.bind(this)), this.b.observe(this.a, { childList: !0, subtree: !0 }));
  }function ua(a) {
    a.b && a.b.disconnect();
  }ta.prototype.f = function (a) {
    var b = this.a.readyState;"interactive" !== b && "complete" !== b || ua(this);for (b = 0; b < a.length; b++) {
      for (var c = a[b].addedNodes, f = 0; f < c.length; f++) {
        N(this.c, c[f]);
      }
    }
  };function va() {
    var a = this;this.b = this.a = void 0;this.c = new Promise(function (b) {
      a.b = b;a.a && b(a.a);
    });
  }function wa(a) {
    if (a.a) throw Error("Already resolved.");a.a = void 0;a.b && a.b(void 0);
  };function O(a) {
    this.f = new Map();this.g = new Map();this.l = new Map();this.i = !1;this.b = a;this.j = new Map();this.c = function (b) {
      return b();
    };this.a = !1;this.h = [];this.m = a.f ? new ta(a) : void 0;
  }O.prototype.o = function (a, b) {
    var c = this;if (!(b instanceof Function)) throw new TypeError("Custom element constructor getters must be functions.");xa(this, a);this.f.set(a, b);this.h.push(a);this.a || (this.a = !0, this.c(function () {
      return ya(c);
    }));
  };
  O.prototype.define = function (a, b) {
    var c = this;if (!(b instanceof Function)) throw new TypeError("Custom element constructors must be functions.");xa(this, a);za(this, a, b);this.h.push(a);this.a || (this.a = !0, this.c(function () {
      return ya(c);
    }));
  };function xa(a, b) {
    if (!ra(b)) throw new SyntaxError("The element name '" + b + "' is not valid.");if (P(a, b)) throw Error("A custom element with name '" + b + "' has already been defined.");if (a.i) throw Error("A custom element is already being defined.");
  }
  function za(a, b, c) {
    a.i = !0;var f;try {
      var d = function d(m) {
        var w = e[m];if (void 0 !== w && !(w instanceof Function)) throw Error("The '" + m + "' callback must be a function.");return w;
      },
          e = c.prototype;if (!(e instanceof Object)) throw new TypeError("The custom element constructor's prototype is not an object.");var g = d("connectedCallback");var h = d("disconnectedCallback");var k = d("adoptedCallback");var l = (f = d("attributeChangedCallback")) && c.observedAttributes || [];
    } catch (m) {
      throw m;
    } finally {
      a.i = !1;
    }c = { localName: b, constructorFunction: c,
      connectedCallback: g, disconnectedCallback: h, adoptedCallback: k, attributeChangedCallback: f, observedAttributes: l, constructionStack: [] };a.g.set(b, c);a.l.set(c.constructorFunction, c);return c;
  }O.prototype.upgrade = function (a) {
    N(this.b, a);
  };
  function ya(a) {
    if (!1 !== a.a) {
      a.a = !1;for (var b = [], c = a.h, f = new Map(), d = 0; d < c.length; d++) {
        f.set(c[d], []);
      }N(a.b, document, { upgrade: function upgrade(k) {
          if (void 0 === k.__CE_state) {
            var l = k.localName,
                m = f.get(l);m ? m.push(k) : a.g.has(l) && b.push(k);
          }
        } });for (d = 0; d < b.length; d++) {
        Q(a.b, b[d]);
      }for (d = 0; d < c.length; d++) {
        for (var e = c[d], g = f.get(e), h = 0; h < g.length; h++) {
          Q(a.b, g[h]);
        }(e = a.j.get(e)) && wa(e);
      }c.length = 0;
    }
  }O.prototype.get = function (a) {
    if (a = P(this, a)) return a.constructorFunction;
  };
  O.prototype.whenDefined = function (a) {
    if (!ra(a)) return Promise.reject(new SyntaxError("'" + a + "' is not a valid custom element name."));var b = this.j.get(a);if (b) return b.c;b = new va();this.j.set(a, b);var c = this.g.has(a) || this.f.has(a);a = -1 === this.h.indexOf(a);c && a && wa(b);return b.c;
  };O.prototype.polyfillWrapFlushCallback = function (a) {
    this.m && ua(this.m);var b = this.c;this.c = function (c) {
      return a(function () {
        return b(c);
      });
    };
  };
  function P(a, b) {
    var c = a.g.get(b);if (c) return c;if (c = a.f.get(b)) {
      a.f.delete(b);try {
        return za(a, b, c());
      } catch (f) {
        R(f);
      }
    }
  }window.CustomElementRegistry = O;O.prototype.define = O.prototype.define;O.prototype.upgrade = O.prototype.upgrade;O.prototype.get = O.prototype.get;O.prototype.whenDefined = O.prototype.whenDefined;O.prototype.polyfillDefineLazy = O.prototype.o;O.prototype.polyfillWrapFlushCallback = O.prototype.polyfillWrapFlushCallback;function S() {
    var a = T && T.noDocumentConstructionObserver,
        b = T && T.shadyDomFastWalk;this.b = [];this.c = [];this.a = !1;this.shadyDomFastWalk = b;this.f = !a;
  }function U(a, b, c, f) {
    var d = window.ShadyDOM;if (a.shadyDomFastWalk && d && d.inUse) {
      if (b.nodeType === Node.ELEMENT_NODE && c(b), b.querySelectorAll) for (a = d.nativeMethods.querySelectorAll.call(b, "*"), b = 0; b < a.length; b++) {
        c(a[b]);
      }
    } else L(b, c, f);
  }function Aa(a, b) {
    a.a = !0;a.b.push(b);
  }function Ba(a, b) {
    a.a = !0;a.c.push(b);
  }function V(a, b) {
    a.a && U(a, b, function (c) {
      return W(a, c);
    });
  }
  function W(a, b) {
    if (a.a && !b.__CE_patched) {
      b.__CE_patched = !0;for (var c = 0; c < a.b.length; c++) {
        a.b[c](b);
      }for (c = 0; c < a.c.length; c++) {
        a.c[c](b);
      }
    }
  }function X(a, b) {
    var c = [];U(a, b, function (d) {
      return c.push(d);
    });for (b = 0; b < c.length; b++) {
      var f = c[b];1 === f.__CE_state ? a.connectedCallback(f) : Q(a, f);
    }
  }function Y(a, b) {
    var c = [];U(a, b, function (d) {
      return c.push(d);
    });for (b = 0; b < c.length; b++) {
      var f = c[b];1 === f.__CE_state && a.disconnectedCallback(f);
    }
  }
  function N(a, b, c) {
    c = void 0 === c ? {} : c;var f = c.s,
        d = c.upgrade || function (g) {
      return Q(a, g);
    },
        e = [];U(a, b, function (g) {
      a.a && W(a, g);if ("link" === g.localName && "import" === g.getAttribute("rel")) {
        var h = g.import;h instanceof Node && (h.__CE_isImportDocument = !0, h.__CE_registry = document.__CE_registry);h && "complete" === h.readyState ? h.__CE_documentLoadHandled = !0 : g.addEventListener("load", function () {
          var k = g.import;if (!k.__CE_documentLoadHandled) {
            k.__CE_documentLoadHandled = !0;var l = new Set();f && (f.forEach(function (m) {
              return l.add(m);
            }), l.delete(k));N(a, k, { s: l, upgrade: d });
          }
        });
      } else e.push(g);
    }, f);for (b = 0; b < e.length; b++) {
      d(e[b]);
    }
  }
  function Q(a, b) {
    try {
      var c = b.ownerDocument,
          f = c.__CE_registry;var d = f && (c.defaultView || c.__CE_isImportDocument) ? P(f, b.localName) : void 0;if (d && void 0 === b.__CE_state) {
        d.constructionStack.push(b);try {
          try {
            if (new d.constructorFunction() !== b) throw Error("The custom element constructor did not produce the element being upgraded.");
          } finally {
            d.constructionStack.pop();
          }
        } catch (k) {
          throw b.__CE_state = 2, k;
        }b.__CE_state = 1;b.__CE_definition = d;if (d.attributeChangedCallback && b.hasAttributes()) {
          var e = d.observedAttributes;
          for (d = 0; d < e.length; d++) {
            var g = e[d],
                h = b.getAttribute(g);null !== h && a.attributeChangedCallback(b, g, null, h, null);
          }
        }I(b) && a.connectedCallback(b);
      }
    } catch (k) {
      R(k);
    }
  }S.prototype.connectedCallback = function (a) {
    var b = a.__CE_definition;if (b.connectedCallback) try {
      b.connectedCallback.call(a);
    } catch (c) {
      R(c);
    }
  };S.prototype.disconnectedCallback = function (a) {
    var b = a.__CE_definition;if (b.disconnectedCallback) try {
      b.disconnectedCallback.call(a);
    } catch (c) {
      R(c);
    }
  };
  S.prototype.attributeChangedCallback = function (a, b, c, f, d) {
    var e = a.__CE_definition;if (e.attributeChangedCallback && -1 < e.observedAttributes.indexOf(b)) try {
      e.attributeChangedCallback.call(a, b, c, f, d);
    } catch (g) {
      R(g);
    }
  };
  function Ca(a, b, c, f) {
    var d = b.__CE_registry;if (d && (null === f || "http://www.w3.org/1999/xhtml" === f) && (d = P(d, c))) try {
      var e = new d.constructorFunction();if (void 0 === e.__CE_state || void 0 === e.__CE_definition) throw Error("Failed to construct '" + c + "': The returned value was not constructed with the HTMLElement constructor.");if ("http://www.w3.org/1999/xhtml" !== e.namespaceURI) throw Error("Failed to construct '" + c + "': The constructed element's namespace must be the HTML namespace.");if (e.hasAttributes()) throw Error("Failed to construct '" + c + "': The constructed element must not have any attributes.");if (null !== e.firstChild) throw Error("Failed to construct '" + c + "': The constructed element must not have any children.");if (null !== e.parentNode) throw Error("Failed to construct '" + c + "': The constructed element must not have a parent node.");if (e.ownerDocument !== b) throw Error("Failed to construct '" + c + "': The constructed element's owner document is incorrect.");if (e.localName !== c) throw Error("Failed to construct '" + c + "': The constructed element's local name is incorrect.");
      return e;
    } catch (g) {
      return R(g), b = null === f ? n.call(b, c) : p.call(b, f, c), Object.setPrototypeOf(b, HTMLUnknownElement.prototype), b.__CE_state = 2, b.__CE_definition = void 0, W(a, b), b;
    }b = null === f ? n.call(b, c) : p.call(b, f, c);W(a, b);return b;
  }
  function R(a) {
    var b = a.message,
        c = a.sourceURL || a.fileName || "",
        f = a.line || a.lineNumber || 0,
        d = a.column || a.columnNumber || 0,
        e = void 0;void 0 === ErrorEvent.prototype.initErrorEvent ? e = new ErrorEvent("error", { cancelable: !0, message: b, filename: c, lineno: f, colno: d, error: a }) : (e = document.createEvent("ErrorEvent"), e.initErrorEvent("error", !1, !0, b, c, f), e.preventDefault = function () {
      Object.defineProperty(this, "defaultPrevented", { configurable: !0, get: function get() {
          return !0;
        } });
    });void 0 === e.error && Object.defineProperty(e, "error", { configurable: !0, enumerable: !0, get: function get() {
        return a;
      } });window.dispatchEvent(e);e.defaultPrevented || console.error(a);
  };var Da = new function () {}();function Ea(a) {
    window.HTMLElement = function () {
      function b() {
        var c = this.constructor;var f = document.__CE_registry.l.get(c);if (!f) throw Error("Failed to construct a custom element: The constructor was not registered with `customElements`.");var d = f.constructionStack;if (0 === d.length) return d = n.call(document, f.localName), Object.setPrototypeOf(d, c.prototype), d.__CE_state = 1, d.__CE_definition = f, W(a, d), d;var e = d.length - 1,
            g = d[e];if (g === Da) throw Error("Failed to construct '" + f.localName + "': This element was already constructed.");
        d[e] = Da;Object.setPrototypeOf(g, c.prototype);W(a, g);return g;
      }b.prototype = na.prototype;Object.defineProperty(b.prototype, "constructor", { writable: !0, configurable: !0, enumerable: !1, value: b });return b;
    }();
  };function Z(a, b, c) {
    function f(d) {
      return function (e) {
        for (var g = [], h = 0; h < arguments.length; ++h) {
          g[h] = arguments[h];
        }h = [];for (var k = [], l = 0; l < g.length; l++) {
          var m = g[l];m instanceof Element && I(m) && k.push(m);if (m instanceof DocumentFragment) for (m = m.firstChild; m; m = m.nextSibling) {
            h.push(m);
          } else h.push(m);
        }d.apply(this, g);for (g = 0; g < k.length; g++) {
          Y(a, k[g]);
        }if (I(this)) for (g = 0; g < h.length; g++) {
          k = h[g], k instanceof Element && X(a, k);
        }
      };
    }void 0 !== c.prepend && M(b, "prepend", f(c.prepend));void 0 !== c.append && M(b, "append", f(c.append));
  }
  ;function Fa(a) {
    M(Document.prototype, "createElement", function (b) {
      return Ca(a, this, b, null);
    });M(Document.prototype, "importNode", function (b, c) {
      b = aa.call(this, b, !!c);this.__CE_registry ? N(a, b) : V(a, b);return b;
    });M(Document.prototype, "createElementNS", function (b, c) {
      return Ca(a, this, c, b);
    });Z(a, Document.prototype, { prepend: ba, append: ca });
  };function Ga(a) {
    function b(c, f) {
      Object.defineProperty(c, "textContent", { enumerable: f.enumerable, configurable: !0, get: f.get, set: function set(d) {
          if (this.nodeType === Node.TEXT_NODE) f.set.call(this, d);else {
            var e = void 0;if (this.firstChild) {
              var g = this.childNodes,
                  h = g.length;if (0 < h && I(this)) {
                e = Array(h);for (var k = 0; k < h; k++) {
                  e[k] = g[k];
                }
              }
            }f.set.call(this, d);if (e) for (d = 0; d < e.length; d++) {
              Y(a, e[d]);
            }
          }
        } });
    }M(Node.prototype, "insertBefore", function (c, f) {
      if (c instanceof DocumentFragment) {
        var d = J(c);c = t.call(this, c, f);if (I(this)) for (f = 0; f < d.length; f++) {
          X(a, d[f]);
        }return c;
      }d = c instanceof Element && I(c);f = t.call(this, c, f);d && Y(a, c);I(this) && X(a, c);return f;
    });M(Node.prototype, "appendChild", function (c) {
      if (c instanceof DocumentFragment) {
        var f = J(c);c = r.call(this, c);if (I(this)) for (var d = 0; d < f.length; d++) {
          X(a, f[d]);
        }return c;
      }f = c instanceof Element && I(c);d = r.call(this, c);f && Y(a, c);I(this) && X(a, c);return d;
    });M(Node.prototype, "cloneNode", function (c) {
      c = q.call(this, !!c);this.ownerDocument.__CE_registry ? N(a, c) : V(a, c);return c;
    });M(Node.prototype, "removeChild", function (c) {
      var f = c instanceof Element && I(c),
          d = u.call(this, c);f && Y(a, c);return d;
    });M(Node.prototype, "replaceChild", function (c, f) {
      if (c instanceof DocumentFragment) {
        var d = J(c);c = v.call(this, c, f);if (I(this)) for (Y(a, f), f = 0; f < d.length; f++) {
          X(a, d[f]);
        }return c;
      }d = c instanceof Element && I(c);var e = v.call(this, c, f),
          g = I(this);g && Y(a, f);d && Y(a, c);g && X(a, c);return e;
    });x && x.get ? b(Node.prototype, x) : Aa(a, function (c) {
      b(c, { enumerable: !0, configurable: !0, get: function get() {
          for (var f = [], d = this.firstChild; d; d = d.nextSibling) {
            d.nodeType !== Node.COMMENT_NODE && f.push(d.textContent);
          }return f.join("");
        }, set: function set(f) {
          for (; this.firstChild;) {
            u.call(this, this.firstChild);
          }null != f && "" !== f && r.call(this, document.createTextNode(f));
        } });
    });
  };function Ha(a) {
    function b(f) {
      return function (d) {
        for (var e = [], g = 0; g < arguments.length; ++g) {
          e[g] = arguments[g];
        }g = [];for (var h = [], k = 0; k < e.length; k++) {
          var l = e[k];l instanceof Element && I(l) && h.push(l);if (l instanceof DocumentFragment) for (l = l.firstChild; l; l = l.nextSibling) {
            g.push(l);
          } else g.push(l);
        }f.apply(this, e);for (e = 0; e < h.length; e++) {
          Y(a, h[e]);
        }if (I(this)) for (e = 0; e < g.length; e++) {
          h = g[e], h instanceof Element && X(a, h);
        }
      };
    }var c = Element.prototype;void 0 !== ja && M(c, "before", b(ja));void 0 !== ka && M(c, "after", b(ka));void 0 !== la && M(c, "replaceWith", function (f) {
      for (var d = [], e = 0; e < arguments.length; ++e) {
        d[e] = arguments[e];
      }e = [];for (var g = [], h = 0; h < d.length; h++) {
        var k = d[h];k instanceof Element && I(k) && g.push(k);if (k instanceof DocumentFragment) for (k = k.firstChild; k; k = k.nextSibling) {
          e.push(k);
        } else e.push(k);
      }h = I(this);la.apply(this, d);for (d = 0; d < g.length; d++) {
        Y(a, g[d]);
      }if (h) for (Y(a, this), d = 0; d < e.length; d++) {
        g = e[d], g instanceof Element && X(a, g);
      }
    });void 0 !== ma && M(c, "remove", function () {
      var f = I(this);ma.call(this);f && Y(a, this);
    });
  };function Ia(a) {
    function b(d, e) {
      Object.defineProperty(d, "innerHTML", { enumerable: e.enumerable, configurable: !0, get: e.get, set: function set(g) {
          var h = this,
              k = void 0;I(this) && (k = [], U(a, this, function (w) {
            w !== h && k.push(w);
          }));e.set.call(this, g);if (k) for (var l = 0; l < k.length; l++) {
            var m = k[l];1 === m.__CE_state && a.disconnectedCallback(m);
          }this.ownerDocument.__CE_registry ? N(a, this) : V(a, this);return g;
        } });
    }function c(d, e) {
      M(d, "insertAdjacentElement", function (g, h) {
        var k = I(h);g = e.call(this, g, h);k && Y(a, h);I(g) && X(a, h);return g;
      });
    }
    function f(d, e) {
      function g(h, k) {
        for (var l = []; h !== k; h = h.nextSibling) {
          l.push(h);
        }for (k = 0; k < l.length; k++) {
          N(a, l[k]);
        }
      }M(d, "insertAdjacentHTML", function (h, k) {
        h = h.toLowerCase();if ("beforebegin" === h) {
          var l = this.previousSibling;e.call(this, h, k);g(l || this.parentNode.firstChild, this);
        } else if ("afterbegin" === h) l = this.firstChild, e.call(this, h, k), g(this.firstChild, l);else if ("beforeend" === h) l = this.lastChild, e.call(this, h, k), g(l || this.firstChild, null);else if ("afterend" === h) l = this.nextSibling, e.call(this, h, k), g(this.nextSibling, l);else throw new SyntaxError("The value provided (" + String(h) + ") is not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'.");
      });
    }y && M(Element.prototype, "attachShadow", function (d) {
      d = y.call(this, d);if (a.a && !d.__CE_patched) {
        d.__CE_patched = !0;for (var e = 0; e < a.b.length; e++) {
          a.b[e](d);
        }
      }return this.__CE_shadowRoot = d;
    });z && z.get ? b(Element.prototype, z) : H && H.get ? b(HTMLElement.prototype, H) : Ba(a, function (d) {
      b(d, { enumerable: !0, configurable: !0, get: function get() {
          return q.call(this, !0).innerHTML;
        }, set: function set(e) {
          var g = "template" === this.localName,
              h = g ? this.content : this,
              k = p.call(document, this.namespaceURI, this.localName);for (k.innerHTML = e; 0 < h.childNodes.length;) {
            u.call(h, h.childNodes[0]);
          }for (e = g ? k.content : k; 0 < e.childNodes.length;) {
            r.call(h, e.childNodes[0]);
          }
        } });
    });M(Element.prototype, "setAttribute", function (d, e) {
      if (1 !== this.__CE_state) return B.call(this, d, e);var g = A.call(this, d);B.call(this, d, e);e = A.call(this, d);a.attributeChangedCallback(this, d, g, e, null);
    });M(Element.prototype, "setAttributeNS", function (d, e, g) {
      if (1 !== this.__CE_state) return E.call(this, d, e, g);var h = D.call(this, d, e);E.call(this, d, e, g);g = D.call(this, d, e);a.attributeChangedCallback(this, e, h, g, d);
    });M(Element.prototype, "removeAttribute", function (d) {
      if (1 !== this.__CE_state) return C.call(this, d);var e = A.call(this, d);C.call(this, d);null !== e && a.attributeChangedCallback(this, d, e, null, null);
    });M(Element.prototype, "removeAttributeNS", function (d, e) {
      if (1 !== this.__CE_state) return F.call(this, d, e);var g = D.call(this, d, e);F.call(this, d, e);var h = D.call(this, d, e);g !== h && a.attributeChangedCallback(this, e, g, h, d);
    });oa ? c(HTMLElement.prototype, oa) : G && c(Element.prototype, G);pa ? f(HTMLElement.prototype, pa) : fa && f(Element.prototype, fa);Z(a, Element.prototype, { prepend: ha, append: ia });Ha(a);
  };var T = window.customElements;function Ja() {
    var a = new S();Ea(a);Fa(a);Z(a, DocumentFragment.prototype, { prepend: da, append: ea });Ga(a);Ia(a);a = new O(a);document.__CE_registry = a;Object.defineProperty(window, "customElements", { configurable: !0, enumerable: !0, value: a });
  }T && !T.forcePolyfill && "function" == typeof T.define && "function" == typeof T.get || Ja();window.__CE_installPolyfill = Ja;
}).call(self);

//# sourceMappingURL=custom-elements.min.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function () {
  'use strict';

  // Exit early if we're not running in a browser.

  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object') {
    return;
  }

  // Exit early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.
  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return;
  }

  /**
   * Returns the embedding frame element, if any.
   * @param {!Document} doc
   * @return {!Element}
   */
  function getFrameElement(doc) {
    try {
      return doc.defaultView && doc.defaultView.frameElement || null;
    } catch (e) {
      // Ignore the error.
      return null;
    }
  }

  /**
   * A local reference to the root document.
   */
  var document = function (startDoc) {
    var doc = startDoc;
    var frame = getFrameElement(doc);
    while (frame) {
      doc = frame.ownerDocument;
      frame = getFrameElement(doc);
    }
    return doc;
  }(window.document);

  /**
   * An IntersectionObserver registry. This registry exists to hold a strong
   * reference to IntersectionObserver instances currently observing a target
   * element. Without this registry, instances without another reference may be
   * garbage collected.
   */
  var registry = [];

  /**
   * The signal updater for cross-origin intersection. When not null, it means
   * that the polyfill is configured to work in a cross-origin mode.
   * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
   */
  var crossOriginUpdater = null;

  /**
   * The current cross-origin intersection. Only used in the cross-origin mode.
   * @type {DOMRect|ClientRect}
   */
  var crossOriginRect = null;

  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */
  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = ensureDOMRect(entry.rootBounds);
    this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
    this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
    this.isIntersecting = !!entry.intersectionRect;

    // Calculates the intersection ratio.
    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height;

    // Sets intersection ratio.
    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }

  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */
  function IntersectionObserver(callback, opt_options) {

    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1) {
      throw new Error('root must be an Element');
    }

    // Binds and throttles `this._checkForIntersections`.
    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

    // Private properties.
    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin);

    // Public properties.
    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');

    /** @private @const {!Array<!Document>} */
    this._monitoringDocuments = [];
    /** @private @const {!Array<function()>} */
    this._monitoringUnsubscribes = [];
  }

  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */
  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;

  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */
  IntersectionObserver.prototype.POLL_INTERVAL = null;

  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */
  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;

  /**
   * Sets up the polyfill in the cross-origin mode. The result is the
   * updater function that accepts two arguments: `boundingClientRect` and
   * `intersectionRect` - just as these fields would be available to the
   * parent via `IntersectionObserverEntry`. This function should be called
   * each time the iframe receives intersection information from the parent
   * window, e.g. via messaging.
   * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
   */
  IntersectionObserver._setupCrossOriginUpdater = function () {
    if (!crossOriginUpdater) {
      /**
       * @param {DOMRect|ClientRect} boundingClientRect
       * @param {DOMRect|ClientRect} intersectionRect
       */
      crossOriginUpdater = function crossOriginUpdater(boundingClientRect, intersectionRect) {
        if (!boundingClientRect || !intersectionRect) {
          crossOriginRect = getEmptyRect();
        } else {
          crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
        }
        registry.forEach(function (observer) {
          observer._checkForIntersections();
        });
      };
    }
    return crossOriginUpdater;
  };

  /**
   * Resets the cross-origin mode.
   */
  IntersectionObserver._resetCrossOriginUpdater = function () {
    crossOriginUpdater = null;
    crossOriginRect = null;
  };

  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });

    if (isTargetAlreadyObserved) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();
    this._observationTargets.push({ element: target, entry: null });
    this._monitorIntersections(target.ownerDocument);
    this._checkForIntersections();
  };

  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {
      return item.element != target;
    });
    this._unmonitorIntersections(target.ownerDocument);
    if (this._observationTargets.length == 0) {
      this._unregisterInstance();
    }
  };

  /**
   * Stops observing all target elements for intersection changes.
   */
  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];
    this._unmonitorAllIntersections();
    this._unregisterInstance();
  };

  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */
  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();
    this._queuedEntries = [];
    return records;
  };

  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */
  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];

    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }
      return t !== a[i - 1];
    });
  };

  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */
  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }
      return { value: parseFloat(parts[1]), unit: parts[2] };
    });

    // Handles shorthand.
    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];

    return margins;
  };

  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibility state is visible.
   * @param {!Document} doc
   * @private
   */
  IntersectionObserver.prototype._monitorIntersections = function (doc) {
    var win = doc.defaultView;
    if (!win) {
      // Already destroyed.
      return;
    }
    if (this._monitoringDocuments.indexOf(doc) != -1) {
      // Already monitoring.
      return;
    }

    // Private state for monitoring.
    var callback = this._checkForIntersections;
    var monitoringInterval = null;
    var domObserver = null;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
    } else {
      addEvent(win, 'resize', callback, true);
      addEvent(doc, 'scroll', callback, true);
      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
        domObserver = new win.MutationObserver(callback);
        domObserver.observe(doc, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    this._monitoringDocuments.push(doc);
    this._monitoringUnsubscribes.push(function () {
      // Get the window object again. When a friendly iframe is destroyed, it
      // will be null.
      var win = doc.defaultView;

      if (win) {
        if (monitoringInterval) {
          win.clearInterval(monitoringInterval);
        }
        removeEvent(win, 'resize', callback, true);
      }

      removeEvent(doc, 'scroll', callback, true);
      if (domObserver) {
        domObserver.disconnect();
      }
    });

    // Also monitor the parent.
    if (doc != (this.root && this.root.ownerDocument || document)) {
      var frame = getFrameElement(doc);
      if (frame) {
        this._monitorIntersections(frame.ownerDocument);
      }
    }
  };

  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */
  IntersectionObserver.prototype._unmonitorIntersections = function (doc) {
    var index = this._monitoringDocuments.indexOf(doc);
    if (index == -1) {
      return;
    }

    var rootDoc = this.root && this.root.ownerDocument || document;

    // Check if any dependent targets are still remaining.
    var hasDependentTargets = this._observationTargets.some(function (item) {
      var itemDoc = item.element.ownerDocument;
      // Target is in this context.
      if (itemDoc == doc) {
        return true;
      }
      // Target is nested in this context.
      while (itemDoc && itemDoc != rootDoc) {
        var frame = getFrameElement(itemDoc);
        itemDoc = frame && frame.ownerDocument;
        if (itemDoc == doc) {
          return true;
        }
      }
      return false;
    });
    if (hasDependentTargets) {
      return;
    }

    // Unsubscribe.
    var unsubscribe = this._monitoringUnsubscribes[index];
    this._monitoringDocuments.splice(index, 1);
    this._monitoringUnsubscribes.splice(index, 1);
    unsubscribe();

    // Also unmonitor the parent.
    if (doc != rootDoc) {
      var frame = getFrameElement(doc);
      if (frame) {
        this._unmonitorIntersections(frame.ownerDocument);
      }
    }
  };

  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */
  IntersectionObserver.prototype._unmonitorAllIntersections = function () {
    var unsubscribes = this._monitoringUnsubscribes.slice(0);
    this._monitoringDocuments.length = 0;
    this._monitoringUnsubscribes.length = 0;
    for (var i = 0; i < unsubscribes.length; i++) {
      unsubscribes[i]();
    }
  };

  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */
  IntersectionObserver.prototype._checkForIntersections = function () {
    if (!this.root && crossOriginUpdater && !crossOriginRect) {
      // Cross origin monitoring, but no initial data available yet.
      return;
    }

    var rootIsInDom = this._rootIsInDom();
    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);
      var rootContainsTarget = this._rootContainsTarget(target);
      var oldEntry = item.entry;
      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: crossOriginUpdater && !this.root ? null : rootRect,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };

  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} targetRect The bounding rect of the target.
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */
  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, targetRect, rootRect) {
    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;

    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot && parent) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};

      // If the parent isn't displayed, an intersection can't happen.
      if (parentComputedStyle.display == 'none') return null;

      if (parent == this.root || parent.nodeType == /* DOCUMENT */9) {
        atRoot = true;
        if (parent == this.root || parent == document) {
          if (crossOriginUpdater && !this.root) {
            if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
              // A 0-size cross-origin intersection means no-intersection.
              parent = null;
              parentRect = null;
              intersectionRect = null;
            } else {
              parentRect = crossOriginRect;
            }
          } else {
            parentRect = rootRect;
          }
        } else {
          // Check if there's a frame that can be navigated to.
          var frame = getParentNode(parent);
          var frameRect = frame && getBoundingClientRect(frame);
          var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
          if (frameRect && frameIntersect) {
            parent = frame;
            parentRect = convertFromParentRect(frameRect, frameIntersect);
          } else {
            parent = null;
            intersectionRect = null;
          }
        }
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        var doc = parent.ownerDocument;
        if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      }

      // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.
      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
      }
      if (!intersectionRect) break;
      parent = parent && getParentNode(parent);
    }
    return intersectionRect;
  };

  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {ClientRect} The expanded root rect.
   * @private
   */
  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;
    if (this.root) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var html = document.documentElement;
      var body = document.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }
    return this._expandRectByRootMargin(rootRect);
  };

  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {DOMRect|ClientRect} rect The rect object to expand.
   * @return {ClientRect} The expanded rect.
   * @private
   */
  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });
    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;

    return newRect;
  };

  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */
  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {

    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;

    // Ignore unchanged ratios
    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i];

      // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.
      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };

  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */
  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };

  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */
  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    return containsDeep(this.root || document, target) && (!this.root || this.root.ownerDocument == target.ownerDocument);
  };

  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */
  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };

  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */
  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };

  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */
  function now() {
    return window.performance && performance.now && performance.now();
  }

  /**
   * Throttles a function and delays its execution, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */
  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }

  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */
  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }

  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */
  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }

  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object|?ClientRect} The intersection rect or undefined if no
   *     intersection is found.
   */
  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;

    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    } || null;
  }

  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
   */
  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {
      // Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect();

    // Older IE
    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }
    return rect;
  }

  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {ClientRect} The empty rect.
   */
  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }

  /**
   * Ensure that the result has all of the necessary fields of the DOMRect.
   * Specifically this ensures that `x` and `y` fields are set.
   *
   * @param {?DOMRect|?ClientRect} rect
   * @return {?DOMRect}
   */
  function ensureDOMRect(rect) {
    // A `DOMRect` object has `x` and `y` fields.
    if (!rect || 'x' in rect) {
      return rect;
    }
    // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
    // for internally calculated Rect objects. For the purposes of
    // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
    // for these fields.
    return {
      top: rect.top,
      y: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      x: rect.left,
      right: rect.right,
      width: rect.width,
      height: rect.height
    };
  }

  /**
   * Inverts the intersection and bounding rect from the parent (frame) BCR to
   * the local BCR space.
   * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
   * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
   * @return {ClientRect} The local root bounding rect for the parent's children.
   */
  function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
    var top = parentIntersectionRect.top - parentBoundingRect.top;
    var left = parentIntersectionRect.left - parentBoundingRect.left;
    return {
      top: top,
      left: left,
      height: parentIntersectionRect.height,
      width: parentIntersectionRect.width,
      bottom: top + parentIntersectionRect.height,
      right: left + parentIntersectionRect.width
    };
  }

  /**
   * Checks to see if a parent element contains a child element (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */
  function containsDeep(parent, child) {
    var node = child;
    while (node) {
      if (node == parent) return true;

      node = getParentNode(node);
    }
    return false;
  }

  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */
  function getParentNode(node) {
    var parent = node.parentNode;

    if (node.nodeType == /* DOCUMENT */9 && node != document) {
      // If this node is a document node, look for the embedding frame.
      return getFrameElement(node);
    }

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }

    if (parent && parent.assignedSlot) {
      // If the parent is distributed in a <slot>, return the parent of a slot.
      return parent.assignedSlot.parentNode;
    }

    return parent;
  }

  // Exposes the constructors globally.
  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// article-video-loop-bundle-v2-69f1813fc7db818dad04.js